// Firefox fix for @react-pdf/renderer -> cross-fetch@3.2.0, which exports an
// UNBOUND window.fetch (dist/browser-ponyfill.js: `exports.default = ctx.fetch`).
// Calling it with this === undefined makes Firefox throw:
//   "'fetch' called on an object that does not implement interface Window".
// Binding the global here, before cross-fetch's module evaluates, makes it
// capture the bound reference. Chrome/Safari are unaffected either way.
if (typeof window !== "undefined" && typeof window.fetch === "function") {
  window.fetch = window.fetch.bind(window);
}
